import styled from 'styled-components'
import { MOBILE_SIZE_BREAKPOINT } from 'consts'
import { COLORS } from 'consts/colors'

export const TtsFooterWrapper = styled.div`
  position: sticky;
  bottom: 0;
  flex-shrink: 0;

  width: 100%;
  padding: 16px 15px;
  border-top: 1px solid ${COLORS.borderColor};

  display: flex;
  flex-direction: column;
  gap: 8px;

  @media screen and (max-height: ${MOBILE_SIZE_BREAKPOINT}px) {
    background-color: ${COLORS.white};
    z-index: 1;
  }
`
